import * as React from "react";
import clsx from "clsx";
import { useAnalyticsTrigger } from "../../helpers/analytics/use-analytics-trigger.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { usePropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Star } from "./star.mjs";
const Rating = (props) => {
  var _a;
  const [selectedStar, setSelectedStar] = React.useState((_a = props.defaultValue) != null ? _a : 0);
  const [hoveredStar, setHoveredStar] = React.useState(null);
  const {
    label,
    labelSize = "h4",
    labelClassName,
    ratingLabels,
    align = "left",
    required,
    onChange: onChangeProp,
    value,
    theme,
    name = "rating",
    className,
    helpMessage,
    errorMessage,
    successMessage,
    employeeMessage
  } = props;
  usePropsChecker({
    componentProps: props,
    componentName: "Rating",
    defaultValueName: "defaultValue",
    valueName: "value",
    onChangeNames: "onChange"
  });
  const { onChange } = useAnalyticsTrigger(
    {
      callback: "onChange",
      id: ([value2]) => "Rating - Check - ".concat(value2),
      elementId: name,
      elementType: "radio",
      interactionType: "check"
    },
    { onChange: onChangeProp }
  );
  const currentValue = onChangeProp && value !== void 0 ? value : selectedStar;
  const scale = Object.keys(ratingLabels).length;
  const getRatingLabel = (rating) => {
    return ratingLabels[rating] || "";
  };
  const renderRatingLabel = () => {
    if (hoveredStar) {
      return "".concat(hoveredStar, " - ").concat(getRatingLabel(hoveredStar));
    }
    if (currentValue > 0) {
      return "".concat(currentValue, " - ").concat(getRatingLabel(currentValue));
    }
    return " ";
  };
  const renderFormHelper = () => {
    const formHelperClass = "rating__form-helper";
    return /* @__PURE__ */ React.createElement(React.Fragment, null, helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { id: "".concat(name, "-help"), text: helpMessage, type: "help", className: formHelperClass }), errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { id: "".concat(name, "-error"), text: errorMessage, type: "error", className: formHelperClass }), successMessage && /* @__PURE__ */ React.createElement(FormHelper, { id: "".concat(name, "-success"), text: successMessage, type: "valid", className: formHelperClass }), employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { id: "".concat(name, "-employee"), text: employeeMessage, type: "employee", className: formHelperClass }));
  };
  const handleSelect = (starIndex) => {
    if (value === void 0) {
      setSelectedStar(starIndex);
    }
    onChange == null ? void 0 : onChange(starIndex);
  };
  return /* @__PURE__ */ React.createElement(
    "fieldset",
    {
      "data-theme": theme,
      className: clsx("rating", "rating--".concat(align), className),
      role: "radiogroup",
      "aria-required": required,
      "aria-labelledby": "".concat(name, "-legend"),
      "aria-describedby": clsx({
        ["".concat(name, "-help")]: helpMessage,
        ["".concat(name, "-error")]: errorMessage,
        ["".concat(name, "-success")]: successMessage,
        ["".concat(name, "-employee")]: employeeMessage
      })
    },
    /* @__PURE__ */ React.createElement("legend", { id: "".concat(name, "-legend"), className: clsx("rating__label", labelSize, labelClassName) }, label),
    renderFormHelper(),
    /* @__PURE__ */ React.createElement("div", { className: "rating__stars-container" }, /* @__PURE__ */ React.createElement("div", { className: "rating__stars" }, Array.from({ length: scale }, (_, index) => /* @__PURE__ */ React.createElement(
      Star,
      {
        key: index,
        name,
        index,
        currentValue,
        required,
        handleSelect,
        ratingLabels,
        invalidMessage: Boolean(errorMessage),
        hoveredStar,
        onHover: setHoveredStar
      }
    ))), /* @__PURE__ */ React.createElement("div", { className: "rating__rating-label", "aria-hidden": true, "data-testid": "rating-label" }, renderRatingLabel()))
  );
};
export {
  Rating
};
